const MemberConfigurationDatastoreDTD = {
  auth_type: {
    type: 'enum',
    typeDef: 'AuthTypeEnum',
    defaultValue: 'NATIVE'
  },
  login_footer_url: 'string',
  login_header_url: 'string',
  login_url: 'string',
  logout_url: 'string',
  theme_primary_color: 'string',
  inst_name: 'string',
  hello_completed: {
    optional: true,
    type: 'tri-state',
    defaultValue: false
  }, // helloCompleted
  render_type: {
    type: 'enum',
    typeDef: 'RenderTypeEnum',
    defaultValue: 'BUTTON_ONLY_LOGIN'
  },
  institution_media_paths: 'object',
  section_label: 'string',
  user_id_label: {
    type: 'string',
    defaultValue: 'Enter your User ID'
  }, // userIdLabel
  login_config_message: 'string'
};
export interface IMemberConfigurationDatastore
  extends Record<keyof typeof MemberConfigurationDatastoreDTD, string | Record<string, string>> {}
export class MemberConfigurationDatastore {
  private id: string;
  public store: any;
  constructor(private Interface: any) {
    this.id = 'login-configuration';
    this.store = {};
    this.initialize();
  }

  update(data: any) {
    this.store = this.Interface.make(MemberConfigurationDatastoreDTD, data);
    return this;
  }

  initialize() {
    this.store = this.Interface.generate(MemberConfigurationDatastoreDTD);
    return this;
  }

  externalize() {
    return this.Interface.serialize(MemberConfigurationDatastoreDTD, this.store);
  }

  read(
    fn: (
      store: IMemberConfigurationDatastore
    ) => IMemberConfigurationDatastore | IMemberConfigurationDatastore[keyof IMemberConfigurationDatastore]
  ) {
    return fn(this.store);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/datastore/member_configuration_datastore.ts